// extracted by mini-css-extract-plugin
export default {"overlay":"Preloader_overlay__wOpol","preloaderWipe":"Preloader_preloaderWipe__lFHUm","word":"Preloader_word__oCPZO","preloaderWord":"Preloader_preloaderWord__gmfKN"};